// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Montenegro from '../_raw/flag/icon_flag_montenegro.png';

export default () => <img src={Montenegro} alt="Montenegro" />;
